import React from 'react'
import './../assets/table.css'
import AllListContent from './AllListContent'
import {
  Query
} from 'react-apollo'
import {
  getSensorIds
} from '../utils/trackable'
import {
  CURRENT_METRIC,
  LATEST_METRIC
} from '../query/metric'
import CircularProgress from '@material-ui/core/CircularProgress'
import { omegaClient } from '../graphql/omegaClient'
class AllContent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      latestMetrics: [],
      sensorIds: this.getSensorIds()
    }
    this.pollingInterval = null
    this._isMounted = false
  }

  getSensorIds () {
    return getSensorIds(this.props.trackables) 
  }

  latestMetrics (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: LATEST_METRIC,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.latest_metrics)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  fetchData () {
    this.latestMetrics(this.state.sensorIds)
      .then((latestMetrics) => {
        if (this._isMounted) {
          this.setState({
            latestMetrics
          })
        }
      })
      .catch((error) => {
        console.log('error', error)
      })
  }

  componentDidMount () {
    this._isMounted = true
    // Fetch data immediately
    this.fetchData()

    // Set up polling every 1 minute (60000ms)
    this.pollingInterval = setInterval(() => {
      this.fetchData()
    }, 60000)
  }

  componentWillUnmount () {
    this._isMounted = false
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }

  renderAllListContent () {
    return (
      <div>
        {this.state.latestMetrics.length === 0 ? (
          <CircularProgress style={styles.progressStyle} color='inherit' />
        ) : (
          <AllListContent
            allVehicleIsChecked={this.props.allVehicleIsChecked}
            sensorIds={this.state.sensorIds}
            sortMetrics={this.state.latestMetrics}
            keySearch={this.props.keySearch}
            fetchData={() => this.fetchData()}
            trackables={this.props.trackables}
          />)}
      </div>
    )
  }

  render () {
    const self = this
    return (
      <div style={styles.content}>
        {self.renderAllListContent()}
      </div>
    )
  }
}

const styles = {
  content: {
    width: '100%'
  },
  tableStyle: {
    width: '100%',
    marginTop: '-16px',
    borderSpacing: '0px 12px'
  },
  divStyle: {
    marginRight: '15px'
  },
  listProgressPosition: {
    marginTop: '10%'
  },
  paginationProgressPosition: {
    marginTop: '20%'
  },
  progressStyle: {
    color: '#7ED321'
  }
}

export default AllContent
